// Nav: viết static sẵn trong .MS__outer (include trực tiếp trong .html.twig),
// chỉ cần bind hành vi toggle mở/đóng overlay + resize.
(function () {
  // scale của .MS__outer (lib scale bằng transform) — để tính chiều cao overlay cho khớp viewport
  function scaleOf() {
    var outer = document.querySelector('.MS__outer');
    if (!outer) return 1;
    var t = getComputedStyle(outer).transform;
    var m = t && t !== 'none' ? t.match(/matrix(?:3d)?\(([^,]+)/) : null; // khớp cả matrix() và matrix3d() (mobile transform 3D)
    return m ? (parseFloat(m[1]) || 1) : 1;
  }
  function sizeOverlay(ov) {
    ov.style.height = (window.innerHeight / scaleOf()) + 'px'; // phủ đúng full viewport dù .MS__outer bị scale
  }
  function bind() {
    var btn = document.querySelector('.nav-menu');
    var ov = document.querySelector('.nav-menu-overlay');
    if (!btn || !ov || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      sizeOverlay(ov);
      ov.classList.toggle('active');
    });
    ov.addEventListener('click', function (e) {
      var isItem = e.target.closest('.nav-menu-overlay__item');
      if (isItem) {
        // Bấm 1 mục: KHÔNG đóng overlay ngay — Safari mobile có quirk hủy luôn
        // native anchor-jump (href="#FrameX") nếu phần tử chứa link đang bị click
        // bị ẩn (display:none) ngay trong lúc xử lý sự kiện click của chính nó,
        // vì default action (anchor jump) chỉ chạy SAU khi mọi handler click chạy xong.
        // Dời đóng overlay + dispatch resize ra sau bằng setTimeout để nhảy trang chạy trước.
        setTimeout(function () {
          ov.classList.remove('active');
          window.dispatchEvent(new Event('resize'));
        }, 80);
      } else {
        ov.classList.remove('active'); // bấm nền -> đóng menu ngay
      }
    });
    window.addEventListener('resize', function () { if (ov.classList.contains('active')) sizeOverlay(ov); });
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
